import React from 'react';
import CountUp from 'react-countup';
import TrackVisibility from 'react-on-screen';

const SingleCoolFact = ({countUpValue, suffix, title}) => {
    return (
        <div>
            <TrackVisibility once>
                {({ isVisible }) => (
                <div className='ml-14 dark:text-white'>
                    <h3 className='text-3xl font-bold'>
                        {isVisible ?  <CountUp duration={5} end ={countUpValue} /> : 0 }
                        <span>{suffix}</span>
                    </h3>
                    <p className='text-lg'>{title}</p>
                </div>
                )}
            </TrackVisibility>
        </div>
    );
};

export default SingleCoolFact;